<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title">
          <router-link
            v-if="!serverError"
            :to="{ name: `${routePrefix}.edit`}"
            class="btn btn-primary btn-sm"
            v-can:edit="permissionPrefix"
          >
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div v-if="serverError" class="alert alert-danger">
                <strong>{{ $t("labels.error") }} : </strong> {{ serverError }}
              </div>
            </div>
          </div>
          <div class="row" v-if="!serverError">
            <input-text v-model="legalName" :options="{ id: 'legalName', transPrefix: `${transPrefix}.fields`, label: 'legal_name', disabled: true }"/>
            <input-text v-model="legalNameAr" :options="{ id: 'legalNameAr', transPrefix: `${transPrefix}.fields`, label: 'legal_name_ar', disabled: true }"/>
            <input-email v-model="billingEmail" :options="{ id: 'billingEmail', transPrefix: `${transPrefix}.fields`, label: 'billing_email', disabled: true }"/>
            <input-text v-model="vatNumber" :options="{ id: 'vatNumber', transPrefix: `${transPrefix}.fields`, label: 'vat_number', disabled: true }"/>
            <input-text v-model="crNumber" :options="{ id: 'crNumber', transPrefix: `${transPrefix}.fields`, label: 'cr_number', disabled: true }"/>
            <input-text v-model="zipCode" :options="{ id: 'zipCode', transPrefix: `${transPrefix}.fields`, label: 'zip_code', disabled: true }"/>
            <input-text v-model="poBox" :options="{ id: 'poBox', transPrefix: `${transPrefix}.fields`, label: 'po_box', disabled: true }"/>
            <input-text v-model="addressLine1" :options="{ id: 'addressLine1', transPrefix: `${transPrefix}.fields`, label: 'address_line_1', disabled: true }"/>
            <input-text v-model="addressLine2" :options="{ id: 'addressLine2', transPrefix: `${transPrefix}.fields`, label: 'address_line_2', disabled: true }"/>
            <input-text v-model="invoiceDueDateAfter" :options="{ id: 'invoiceDueDateAfter', transPrefix: `${transPrefix}.fields`, label: 'invoice_due_date_after', disabled: true }"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PLATFORM_DETAILS_SHOW as CRUD_ACTION_SHOW } from "actions/platforms_portal/platform";
const PLATFORMS_CODE = "platforms";
const CRUD_CODE = `${PLATFORMS_CODE}.details`;
const CRUD_PERMISSION_CODE = `partner_platform`;
export default {
  name: "PlatformDetailsShow",
  data() {
    return {
      routePrefix: `platforms_portal.platform`,
      transPrefix: CRUD_CODE,
      permissionPrefix: `${CRUD_PERMISSION_CODE}`,
      platformsRoutePrefix: `${PLATFORMS_CODE}`,
      platformsTransPrefix: `${PLATFORMS_CODE}`,
      billingEmail: "",
      vatNumber: "",
      zipCode: "",
      poBox: "",
      addressLine1: "",
      addressLine2: "",
      legalName: "",
      legalNameAr: "",
      crNumber: "",
      invoiceDueDateAfter : "",
      serverError: "",
      responseStatus: "",
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getItem() {
      this.$store
        .dispatch(CRUD_ACTION_SHOW, {
          platformId: this.id
        })
        .then((response) => {
          this.billingEmail = response.data.billingEmail;
          this.vatNumber = response.data.vatNumber;
          this.zipCode = response.data.zipCode;
          this.poBox = response.data.poBox;
          this.addressLine1 = response.data.addressLine1;
          this.addressLine2 = response.data.addressLine2;
          this.legalName = response.data.legalName;
          this.legalNameAr = response.data.legalNameAr;
          this.crNumber = response.data.crNumber;
          this.invoiceDueDateAfter = response.data.invoiceDueDateAfter;
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = "";

          if (error.response) {
            this.responseStatus = error.response.status;
            let responseData = error.response.data;

            if (responseData.errors) {
              this.fieldErrors = responseData.errors;
            } else {
              this.serverError = "Invalid Request.";
            }
          } else {
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if (this.fieldErrors.error) {
            this.serverError = this.fieldErrors.error;
          }
        });
    },
  },
};
</script>
